import './App.css';
import Service from './pages/Service';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from './components/common/Header';
import Home from './pages/Home';
import About from './pages/About';
import Footer from './components/common/Footer';
import Contact from './pages/Contact';
import ScrollToTop from './components/common/ScrollToTop';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Cookie from './pages/Cookie';

function Layout() {
  const location = useLocation(); // ✅ Now inside Router
  const hideHeader = ["/terms", "/privacy", "/cookie"].includes(location.pathname);


  return (
    <>
      <ScrollToTop />
      {!hideHeader && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="service" element={<Service />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="cookie" element={<Cookie />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
